"use client";
import { useState, useEffect } from "react";
import axios from "axios";

const SalesManagement = () => {
  const [sales, setSales] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    fetchSales();
  }, []);

  const fetchSales = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        `https://logicx.premierlam.com/api/pixel-get-all-sales`,
        {
          headers: {
            authorization: localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        }
      );

      setSales(res.data.data || []);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });

  const filteredSales = sales.filter(
    (s) =>
      s.product_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      s.product_master_code.toLowerCase().includes(searchTerm.toLowerCase()) ||
      s.order_id.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredSales.length / rowsPerPage);
  const paginatedSales = filteredSales.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <div className="p-4 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto">

        {/* HEADER */}
        <div className="flex justify-between items-start mb-6">
          <div>
            <h1 className="text-2xl font-semibold text-gray-900 mb-1">Sales</h1>
            <p className="text-gray-500">View all sales records</p>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
          <input
            type="text"
            placeholder="Search by name / code / order ID..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none w-64 mb-4"
          />

          {/* TABLE */}
          <div className="overflow-x-auto">
            {isLoading ? (
              <div className="text-center py-6 text-gray-500">Loading...</div>
            ) : (
              <table className="w-full border-collapse">
                <thead>
                  <tr className="border-b border-gray-200 text-gray-600 text-sm">
                    <th className="py-3 px-4 text-left">Order ID</th>
                    <th className="py-3 px-4 text-left">Product Code</th>
                    <th className="py-3 px-4 text-left">Product Name</th>
                    <th className="py-3 px-4 text-left">Category</th>
                    <th className="py-3 px-4 text-left">Material</th>
                    <th className="py-3 px-4 text-left">Color</th>
                    <th className="py-3 px-4 text-left">Qty Sold</th>
                    <th className="py-3 px-4 text-left">Selling Price</th>
                    <th className="py-3 px-4 text-left">Total</th>
                    <th className="py-3 px-4 text-left">Return?</th>
                    <th className="py-3 px-4 text-left">RTO</th>
                    <th className="py-3 px-4 text-left">Date</th>
                    <th className="py-3 px-4 text-left">Added By</th>
                    <th className="py-3 px-4 text-left">Created</th>
                  </tr>
                </thead>

                <tbody>
                  {paginatedSales.map((s, i) => (
                    <tr key={i} className="border-b hover:bg-gray-50">
                      <td className="py-3 px-4 text-sm">{s.order_id || "Not Set"}</td>
                      <td className="py-3 px-4 text-sm">{s.product_master_code || "Not Set"}</td>
                      <td className="py-3 px-4 text-sm">{s.product_name || "Not Set"}</td>
                      <td className="py-3 px-4 text-sm">{s.category_name || "Not Set"}</td>
                      <td className="py-3 px-4 text-sm">{s.product_material || "Not Set"}</td>
                      <td className="py-3 px-4 text-sm">{s.product_color || "Not Set"}</td>
                      <td className="py-3 px-4 text-sm">{s.quantity_sold || 0}</td>
                      <td className="py-3 px-4 text-sm">{s.selling_price_per_unit || "0"}</td>
                      <td className="py-3 px-4 text-sm">{s.total_price || "-"} </td>
                      <td className="py-3 px-4 text-sm">{s.sales_return || 0}</td>
                      <td className="py-3 px-4 text-sm">{s.rto_sale_product || "No"}</td>
                      <td className="py-3 px-4 text-sm">{s.Date || "Not Set"}</td>
                      <td className="py-3 px-4 text-sm">{s.added_by || "Not Set"}</td>
                      <td className="py-3 px-4 text-sm">{formatDate(s.created_at)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          {/* PAGINATION */}
          <div className="flex justify-between items-center mt-4 text-sm text-gray-600">
            <span>Page {currentPage} of {totalPages}</span>
            <div className="flex gap-2">
              <button
                onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
                className="px-3 py-1 border rounded-md disabled:opacity-50"
              >
                Prev
              </button>
              <button
                onClick={() => currentPage < totalPages && setCurrentPage(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="px-3 py-1 border rounded-md disabled:opacity-50"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesManagement;

